import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin: auto;
  background-color: #FFF;
  border-radius: 8px;
  width: 75%;
  align-items: center;
  box-shadow: rgba(100, 100, 111, 0.1) 0px 7px 29px 0px;
  padding: 2rem 5rem;
`

export const FormDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
`

export const HeaderText = styled.h2`
  font-weight: 600;
`

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1px;
`

export const Label = styled.label`
  font-weight: 500;
  font-size: 12px;
`

export const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  border: 1px solid #EBEBEB;
  height: 2.4rem;
  max-height: 50px;
  overflow-y: auto;
  padding: 0 .8rem;
  border-radius: 5px;
  :focus{
    border: 1px solid #0090D3;
  }

`

export const ButtonCreate = styled.button`
  background-color: #0090D3;
  color: #FFF;
  padding: .5rem 1rem;
  outline: none;
  border: none;
  font-weight: bold;
  border-radius: 5px;
  cursor: pointer;
`